import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import CompoundService from "services/Admin/CompoundService"
import UnitTypesService from "services/Admin/UnitTypesService"
import LeadService from "services/Admin/LeadService";
import SelectOptions from "components/SelectOptions"
import Select from "react-select";
import moment from "moment"
import { toast } from "react-toastify"

const FilterModal = ({ modal, toggle, onSumbit, filterData }) => {
    const [formState, setFormState] = useState({
        from_date: "",
        to_date: ""
    })
    useEffect(() => {
         if (filterData ?.from_date ?.length) {
            setFormState((state) => ({ ...state, from_date: filterData.from_date }))
        }
        if (filterData ?.to_date ?.length) {
            setFormState((state) => ({ ...state, to_date: filterData.to_date }))
        }
    }, []);
    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = () => {
        if (!formState.from_date && !formState.to_date) {
            onSumbit(formState)
            toggle()

        } else if (moment(formState.to_date).isBefore(formState.from_date)) {
            toast.error("Date range not valid")
            return
        }
        else {
            onSumbit(formState)
            toggle()
        }

    }
    return (
        <AvForm className='form-horizontal' onValidSubmit={(e, v) => handleValidSubmit()} >
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Appointments Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='from_date'
                                    label="from Date"
                                    className='form-control'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.from_date}


                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='to_date'
                                    label=" to Date"
                                    placeholder='Type Date'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.to_date}

                                />
                            </div>
                        </Col>
                    </Row>


                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button
                        type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormState({
                                from_date: "",
                                to_date: ""
                            })
                            onSumbit({
                                from_date: "",
                                to_date: ""
                            })
                        }}>
                        Reset Filter
                       </button>
                    <button type='button'
                        onClick={() => {
                            handleValidSubmit()
                        }}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>

            </Modal>
        </AvForm>

    )
}
export default FilterModal